import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import Dropdown, {
  DropdownTrigger,
  DropdownContent
} from "../../AppBar/Dropdown";
import media from "../../../utils/media";

const AudioDropUpContent = styled(DropdownContent)`
  height: auto;
  width: 100%;
  top: auto;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);

  ${media.tablet`
    width: 300px;
    bottom: 50px;
    left: 12px;
    transform: none;
  `}
`;

const AudioChapterList = styled.div`
  font-family: sans-serif;
  display: flex;
  flex-direction: column;
  padding: 8px 0;
`;

const AudioListItemLink = styled.div`
  font-size: 0.9em;
  transition: all 0.5s ease;
  padding: 8px 16px;
  cursor: pointer;
  color: ${props => props.theme.primaryText};
  &:hover {
    ${({ theme }) =>
      theme.darkMode
        ? `background-color: rgba(211, 211, 211, 0.3);`
        : `color: ${theme.computedPrimary};`}
  }
  &:focus {
    outline: 0;
  }
  ${props =>
    props.selected &&
    css`
      background-color: rgba(211, 211, 211, 0.3);
      border-left: 4px solid
        ${({ theme }) =>
          theme.darkMode ? theme.primary : theme.computedPrimary};
    `};
`;

const StyledDropdownTrigger = styled.div`
  font-family: sans-serif;
  display: inline-block;
  max-width: calc(100vw - 120px);
  overflow: hidden;
  color: ${props => props.theme.appBarText};
  ${media.desktopEmbedSafe`
    max-width: calc(100% - 24px);
    white-space: inherit;
  `}
`;

class AudioVersionDropdown extends Component {
  static propTypes = {
    selectedAudioBibleId: PropTypes.string,
    audioBibles: PropTypes.arrayOf(
      PropTypes.shape({
        nameLocal: PropTypes.string,
        dblId: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string
      })
    ).isRequired,
    onSelectAudioBible: PropTypes.func.isRequired
  };

  static defaultProps = {
    selectedAudioBibleId: null
  };

  state = {
    isOpen: false
  };

  // shouldComponentUpdate = nextProps =>
  //   nextProps.chapter.getCurrentChapter() !== undefined;

  componentDidUpdate = () => {};

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  handleAudioBibleClick = audioBibleId => {
    const { onSelectAudioBible } = this.props;
    onSelectAudioBible(audioBibleId);
    this.toggle();
  };

  render() {
    const { audioBibles, selectedAudioBibleId } = this.props;
    const { isOpen } = this.state;
    const selectedAudioBible = audioBibles.find(audioBible => {
      if (selectedAudioBibleId) {
        return audioBible.id === selectedAudioBibleId;
      }
      return true;
    });

    if (audioBibles.length === 1 && selectedAudioBible) {
      return (
        <StyledDropdownTrigger>
          {selectedAudioBible.nameLocal}
        </StyledDropdownTrigger>
      );
    }
    // const bookId = currentChapter ? currentChapter.bookId : null;
    return (
      selectedAudioBible && (
        <Dropdown isOpen={isOpen} toggle={this.toggle}>
          <DropdownTrigger arrow>
            <StyledDropdownTrigger>
              {selectedAudioBible.nameLocal}
            </StyledDropdownTrigger>
          </DropdownTrigger>
          <AudioDropUpContent>
            <AudioChapterList>
              {audioBibles.map(audioBible => (
                <AudioListItemLink
                  key={audioBible.id}
                  style={{
                    flex: 1
                  }}
                  onClick={() => this.handleAudioBibleClick(audioBible.id)}
                  selected={selectedAudioBible.id === audioBible.id}
                >
                  {audioBible.nameLocal}
                </AudioListItemLink>
              ))}
            </AudioChapterList>
          </AudioDropUpContent>
        </Dropdown>
      )
    );
  }
}

export default AudioVersionDropdown;
